import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export const AbvMediShaTopFiveLineChart = ({ startPeriod, endPeriod, prodIds, stateIds }) => {
  const rsrc = useRsrc();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setLoading(true);
    setData(null); // reset so old chart doesn't flash while loading
    const reqParam = { startPeriod, endPeriod, prodIds, stateIds };
    rsrc.data('gtn', 'MEDI_SHA_TOP_FIVE_LINE_CHART_DATA_PLUGIN', reqParam)
      .then((resp) => { setData(resp); })
      .finally(() => { setLoading(false); });
  }, [startPeriod, endPeriod, prodIds, stateIds]);

  if (loading) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
        <Typography mt={2}>Loading...</Typography>
      </Box>
    );
  }

  if (!data) return null;

  const stateKeys = Object.keys(data || {});
  if (!stateKeys.length) return null;

  const periodSet = new Set();
  stateKeys.forEach((stateKey) => {
    const statePeriods = data[stateKey] || {};
    Object.keys(statePeriods).forEach((periodCode) => periodSet.add(periodCode));
  });

  const periodCodes = Array.from(periodSet).sort();
  if (!periodCodes.length) return null;

  const chartData = {
    categories: periodCodes,
    series: stateKeys.map((stateKey) => {
      const statePeriods = data[stateKey] || {};
      return {
        label: stateKey,
        values: periodCodes.map((periodCode) => Number(statePeriods[periodCode]) || 0),
        type: 'line',
      };
    }),
  };

  return (
    <CartesianChart
      data={chartData}
      legend="top"
      markers={true}
      yLabel="Sales Amount"
    />
  );
};
